import * as React from 'react';
import * as styles from './styles.css';

interface IWrapperProps {
  children: React.ReactElement[];
}
export const PriceDynamicWrapper = React.forwardRef<HTMLDivElement, IWrapperProps>(({ children }, ref) => {
  return (
    <div ref={ref} className={styles['wrapper']}>
      {children}
    </div>
  );
});

PriceDynamicWrapper.displayName = 'PriceDynamicWrapper';
